import { Pipe, PipeTransform } from '@angular/core';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';
import { map } from 'rxjs/operators';
import { LookupsService } from '../../public-api';
import { ShirtCategory, TShirtCategory } from '@ag-common-lib/lib/models/utils/t-shirt-sizes.model';
import { LookupKeys, Lookups } from '@ag-common-lib/public-api';
import { Observable, of } from 'rxjs';
import { LookupsDefaultService } from 'ag-common-svc/lib/services';
import { getShirtCategoryFromSize } from "ag-common-svc/lib/utils/t-shirt-size.utils";

@Pipe({ name: 'tShirtSize' })
export class TShirtSizePipe implements PipeTransform {
  constructor(private lookupsDefaultService: LookupsDefaultService) {}

  transform(sizeValue: string): Observable<string> {
    if (!sizeValue) {
      return of('');
    }

    const category = getShirtCategoryFromSize(sizeValue);

    const lookupName = this.getLookupNameByCategory(category);

    if (!lookupName) {
      return of(sizeValue);
    }

    return this.lookupsDefaultService.getLookupByName(lookupName).pipe(
      map(lookups => {
        if (!Array.isArray(lookups)) {
          return sizeValue;
        }
        return lookups.find(item => item[LookupKeys.value] === sizeValue)?.[LookupKeys.description] ?? sizeValue;
      }),
    );
  }

  private getLookupNameByCategory(category: TShirtCategory | ShirtCategory): Lookups | null {
    switch (category) {
      case TShirtCategory.adult:
        return Lookups.TShirtAdult;
      case TShirtCategory.youth:
        return Lookups.TShirtYouth;
      case ShirtCategory.men:
        return Lookups.ShirtMen;
      case ShirtCategory.women:
        return Lookups.ShirtWomen;
      default:
        return null;
    }
  }
}
